import { connect } from 'react-redux';

import { fetchCalendar } from '../../redux/calendar';
import MonthView from './MonthView';

const mapStateToProps = (state) => ({
  date: state.calendar.date,
  events: state.events.events
});

const mapDispatchToProps = {
  onNavigate: fetchCalendar
};

export default connect(mapStateToProps, mapDispatchToProps)(MonthView);
